import { render, staticRenderFns } from "./addcon.vue?vue&type=template&id=35a70ee2&"
import script from "./addcon.vue?vue&type=script&lang=js&"
export * from "./addcon.vue?vue&type=script&lang=js&"
import style0 from "./addcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports